module.exports = __webpack_public_path__ + "img/main-img.13ae5f9.png";